@import 'styles/mixins';
@import 'styles/blaze/mixins';

.channelList {
  display: flex;
  flex-direction: column;
}

.channelItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px 8px 8px;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 150ms ease;
  background: transparent;
  gap: 9px;
  position: relative;

  &:hover {
    background: var(--dark-2);
    border-radius: 8px;

    .hoverButton,
    .expiredButtonWrapper {
      opacity: 1;
      pointer-events: auto;
    }

    .postedBadge,
    .indicatorFailed,
    .unconnectedIcon {
      opacity: 0;
    }
  }

  &.isSelected {
    background: var(--dark-4);
    border-color: var(--dark-4);
    border-radius: 8px;
  }

  &.isInactive {
    opacity: 0.5;
  }
}

.channelInfo {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
}

.platformIcon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.accountName {
  font-size: 14px;
  line-height: 1.05;
  letter-spacing: 0.14px;
  color: var(--dark-90);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-bottom: 1px;
}

.actions {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.hoverButton,
.expiredButtonWrapper {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  pointer-events: none;
  transition: opacity 150ms ease;
}

.showButton {
  opacity: 1;
  pointer-events: auto;
}

.expiredButtonWrapper {
  display: inline-flex;
}

.expiredButton {
  color: var(--dark-40);
}

.indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 99px;
  padding: 0 0 1px 1px;
  transition: opacity 150ms ease;
}

.indicatorFailed {
  background: #fd4242;
  color: var(--white);
}

.indicatorWarning {
  background: #f6ac00;
  color: var(--dark-90);
  border: 1px solid rgba(0, 0, 0, 0.04);
  padding: 2px;
  border-radius: 16px;
  backdrop-filter: blur(25px);
}

.postedBadge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  padding: 3px;
  border-radius: 99px;
  background: var(--green-50);
  color: var(--white);
  transition: opacity 150ms ease;
}

.unconnectedIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--dark-40);
  transition: opacity 150ms ease;
}

.hideWhenSelected {
  opacity: 0;
}
